module.exports = __webpack_public_path__ + "img/ye.751153f7.svg";